<template>
  <div class="ui-block">
    <div class="ui-block-title">
      <div class="h6 title">
        Showing {{count}} of {{ total }} results for:
        “<span class="c-primary">{{ categories }}</span>”
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "SShowResultBookmark",
  props: ["count","total", "categories"],
};
</script>
